import React from "react";
import { ResourceItem } from "../../slices/resourceListSlice";
import ResourceActionMenu from "../ResourceActionMenu/ResourceActionMenu";
import {
  CheckCircleIcon,
  XCircleIcon,
  StarIcon,
} from "@heroicons/react/24/solid";
import { Column } from "@/components/Datatable/types";

interface CreateResourceColumnsProps {
  onEditResource: (uuid: string) => void;
  onDeleteResource: (uuid: string) => void;
  onViewResource: (slug: string) => void;
}

export function createResourceColumns({
  onEditResource,
  onDeleteResource,
  onViewResource,
}: CreateResourceColumnsProps): Column<ResourceItem>[] {
  return [
    {
      header: "Title",
      accessorKey: "title",
      enableSorting: true,
    },
    {
      header: "Type",
      accessorKey: "resourceType",
      cell: ({ row }) => row.original.resourceType || "—",
    },
    {
      header: "Status",
      accessorKey: "isPublished",
      enableSorting: true,
      cell: ({ row }) => {
        const isPublished = row.original.isPublished;
        return isPublished ? (
          <CheckCircleIcon className="h-5 w-5 text-green-500" />
        ) : (
          <XCircleIcon className="h-5 w-5 text-gray-300 dark:text-gray-600" />
        );
      },
    },
    {
      header: "Featured",
      accessorKey: "isFeatured",
      enableSorting: true,
      cell: ({ row }) => {
        const isFeatured = row.original.isFeatured;
        return isFeatured ? (
          <StarIcon className="h-5 w-5 text-yellow-500" />
        ) : (
          <StarIcon className="h-5 w-5 text-gray-300 dark:text-gray-600" />
        );
      },
    },
    {
      header: "Created At",
      accessorKey: "createdAt",
      enableSorting: true,
      cell: ({ row }) => {
        const val = row.original.createdAt;
        return val ? new Date(val).toLocaleDateString() : "—";
      },
    },
    {
      id: "actions",
      header: "Actions",
      cell: ({ row }) => (
        // Rows navigate to edit on click — keep menu interactions from
        // also triggering the row.
        <div onClick={(e) => e.stopPropagation()}>
          <ResourceActionMenu
            onDeleteResource={onDeleteResource}
            onEditResource={onEditResource}
            onViewResource={onViewResource}
            resourceSlug={row.original.slug}
            resourceUuid={row.original.uuid}
          />
        </div>
      ),
    },
  ];
}
